import React, { useEffect, useState } from "react";
import { CourseCatalog } from "../components/CourseCatalog";
import { fetchAndCachePublicData, getCachedPublicData } from "../utils/publicDataCache";

const COURSE_CACHE_KEY = "public-course-catalog";

function OurCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const cached = getCachedPublicData(COURSE_CACHE_KEY);
    if (cached && active) {
      setCourses(cached.data);
      setLoading(false);
    }

    fetchAndCachePublicData(COURSE_CACHE_KEY, "/courses-public")
      .then((nextCourses) => {
        if (active) {
          setCourses(nextCourses);
        }
      })
      .catch(() => {
        if (active && !cached) {
          setCourses([]);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  const trendingCourses = courses.filter((course) => course.is_trending);
  const regularCourses = courses.filter((course) => !course.is_trending);

  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">Our Courses</h2>
      {loading ? (
        <p className="text-center text-muted">Loading courses...</p>
      ) : (
        <div style={{ display: "grid", gap: "28px" }}>
          <div>
            <h3 className="mb-4">Trending Course</h3>
            <CourseCatalog
              courses={trendingCourses}
              emptyMessage="No trending course available yet."
              columns={{ desktop: 4, tablet: 2, mobile: 1 }}
              itemsPerPage={8}
            />
          </div>
          <div>
            <h3 className="mb-4">All Course</h3>
            <CourseCatalog
              courses={regularCourses}
              emptyMessage="No course available yet."
              columns={{ desktop: 4, tablet: 2, mobile: 1 }}
              itemsPerPage={16}
              enableFilters
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default OurCourses;
